module.exports = __webpack_public_path__ + "static/media/clazzy2.63e78188.png";